import { useTranslation } from 'react-i18next';
import { useAnalyticsPermissions } from '@anytag/auth';
import { Header, ListWithPagination } from '@anytag/shared-molecules';
import { ButtonLink } from '@anytag/shared-atoms';
import { useUpdateDocumentTitle } from '@anytag/shared-hooks';
import { AnalyticsFilter, AnalyticsList, AnalyticsOnboarding } from '@anytag/shared-organisms';
import { useInitialAnalytics } from './hooks';

export const Analytics = () => {
  useUpdateDocumentTitle({ title: 'documentTitle.Analytics', appHeader: 'appHeader.Analytics' });
  const { t } = useTranslation();
  const { hideAddAnalyticsBtn } = useAnalyticsPermissions();
  const { loading, accounts, isOnboarding, totalRecords } = useInitialAnalytics();

  return (
    <div>
      {!isOnboarding ? (
        <Header>
          {!hideAddAnalyticsBtn ? (
            <ButtonLink
              variant="solid"
              to="/analytics/add"
              className="ml-auto min-w-39 capitalize"
              title={t('Button.add account')}
              prefixIcon={{ icon: 'plus', size: '10px' }}
            />
          ) : null}
        </Header>
      ) : null}

      <ListWithPagination pagination={{ totalRecords }} hasNoData={!!isOnboarding} noDataNode={<AnalyticsOnboarding />}>
        <AnalyticsFilter />
        <AnalyticsList data={accounts} loading={loading} totalRecords={totalRecords} />
      </ListWithPagination>
    </div>
  );
};
